import { Injectable } from '@angular/core';

@Injectable()

export class ConfigService {
  serverIp = 'https://api-traelodeusa.logisticscargo.net';
  //  serverIp = 'http://localhost:1337';
  constructor() { }
}
